/* Speediance band selector.
   Loaded only for products carrying custom.band_options.

   The band is not a variant: every unit ships with a band, the shopper chooses
   its colour, and the choice rides on the order as a line item property. What
   this script does is keep the picture honest — whenever the model, the metal
   or the band changes, it brings the gallery to the render of that exact
   combination.

   Image names are deterministic:
     speediance-strap-<case>-band-<band>.jpg   for the three extra bands
     speediance-strap-<case>-01-hero.jpg       for Midnight Dark, the one in the box
*/
(function () {
  var STAMP = '20260929-filtered-gallery';
  if (document.documentElement.dataset.bmBandGuard === STAMP) return;
  document.documentElement.dataset.bmBandGuard = STAMP;

  var DEFAULT_BAND = 'midnight-dark';

  function sectionOf(node) {
    return node && node.closest ? node.closest('.shopify-section') : null;
  }

  function caseSlug(root) {
    var input = root.querySelector('.bm-swatch__input[data-swatch-slug]:checked');
    return input ? input.getAttribute('data-swatch-slug') : null;
  }

  function bandSlug(root) {
    var input = root.querySelector('.bm-band__input:checked');
    return input ? input.getAttribute('data-band-slug') : DEFAULT_BAND;
  }

  function stemFor(caseName, band) {
    if (!caseName) return null;
    if (band === DEFAULT_BAND || !band) return 'strap-' + caseName + '-01-hero';
    return 'strap-' + caseName + '-band-' + band;
  }

  function show(root, stem) {
    if (!stem) return false;
    var slider = root.querySelector('.media-gallery-slider');
    var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('.swiper-slide')) : [];
    if (!slides.length) return false;
    var index = -1;
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      var src = img ? (img.getAttribute('src') || img.currentSrc || '') : '';
      if (src.indexOf(stem) !== -1) { index = i; break; }
    }
    if (index < 0) return false;

    if (slider.swiper && typeof slider.swiper.slideTo === 'function') {
      slider.swiper.slideTo(index);
      var thumbs = root.querySelector('.media-gallery-thumbnail');
      if (thumbs && thumbs.swiper && typeof thumbs.swiper.slideTo === 'function') {
        thumbs.swiper.slideTo(index);
      }
      return true;
    }

    // No Swiper instance: fall back to the gallery element's own API.
    var gallery = root.querySelector('media-gallery');
    var mediaId = slides[index].getAttribute('data-media-id');
    if (gallery && mediaId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId);
      return true;
    }
    return false;
  }

  function sync(root) {
    if (!root) return;
    // The Strap gallery contains only the selected case with its included band.
    // Native variant-response replacement now owns its complete lifecycle.
    if (root.querySelector('media-gallery[data-bm-strap-gallery]')) return;
    if (!root.querySelector('.bm-band__input')) return;
    var readout = root.querySelector('.bm-band-field [data-selected-value]');
    var checked = root.querySelector('.bm-band__input:checked');
    if (readout && checked) readout.textContent = checked.value;
    show(root, stemFor(caseSlug(root), bandSlug(root)));
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('.bm-band__input, .bm-swatch__input, variant-selects input[type="radio"]')) return;
    var root = sectionOf(target);
    if (!root) return;
    if (root.querySelector('media-gallery[data-bm-strap-gallery]')) return;
    // A variant change re-renders the gallery; let that land before moving it.
    if (target.matches('.bm-band__input')) sync(root);
    else setTimeout(function () { sync(root); }, 350);
  });

  function start() {
    document.querySelectorAll('.bm-band-field').forEach(function (field) {
      sync(sectionOf(field));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
